import { gql } from "@apollo/client";
import React, { useMemo } from "react";

import { FavoriteCollectionRow } from "./favorite-projects-and-collection-rows/FavoriteCollectionRow.js";
import { SidebarSection } from "./favorite-projects-and-collection-rows/SidebarSection.js";
import { useGetStarredCollectionsForSidebarQuery } from "./FavoriteCollections.generated.js";

gql`
  fragment StarredCollectionForSidebar on Collection {
    id
    name
    emoji
  }

  query GetStarredCollectionsForSidebar {
    collections(ownershipLevel: ALL, onlyStarred: true, first: 30) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }

      edges {
        node {
          id
          ...StarredCollectionForSidebar
        }
      }
    }
  }
`;

export const FavoriteCollections: React.ComponentType<{
  hideIfEmpty?: boolean;
  location: "popover_sidebar" | "home_sidebar";
}> = React.memo(function FavoriteCollections({
  hideIfEmpty,
  location,
}: {
  hideIfEmpty?: boolean;
  location: "popover_sidebar" | "home_sidebar";
}) {
  const { data, error, loading } = useGetStarredCollectionsForSidebarQuery({
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-first",
  });

  const starredCollections = useMemo(
    () =>
      data?.collections.edges.map(({ node: { emoji, id, name } }) => (
        <FavoriteCollectionRow
          key={id}
          counterEventName={`${location}.favorites.collection.click`}
          emoji={emoji}
          id={id}
          name={name}
        />
      )) ?? [],
    [data?.collections.edges, location],
  );

  return (
    <SidebarSection
      error={error}
      hideIfEmpty={hideIfEmpty}
      items={starredCollections}
      loading={loading}
      localStorageKey="SIDEBAR_FAVORITE_COLLECTIONS_OPENED"
      text="Favorite collections"
    />
  );
});
